import React from 'react';
import './LOFAScheduleDetailRow.scss';
import { GetLofaSchedule_getLofaSchedule as LofaScheduleSummaryData } from '../../../../types/schemaTypes';
import { Textfield } from '../../../_common/Textfield/Textfield';
import { InputTitleEnum } from '../../../_common/InputTitleEnum/InputTitleEnum';

interface LOFAScheduleDetailRowProps {
    lofaScheduleDetail: LofaScheduleSummaryData;
}

const LOFAScheduleDetailRow = ({ lofaScheduleDetail }: LOFAScheduleDetailRowProps): React.ReactElement => {
    return (
        <div className="LOFAScheduleEdit-DetailContainer">
            <div className="LOFASchedule-EditProppantName">
                <Textfield
                    label="PROPPANT TYPE"
                    disabled
                    value={lofaScheduleDetail.proppantName}
                    inputTitle={InputTitleEnum.PROPPANT_NAME}
                />
            </div>
        </div>
    );
};

export default LOFAScheduleDetailRow;
